import React from 'react';
import './DifficultyBadge.css';

interface DifficultyBadgeProps {
  level: number;
}

const DifficultyBadge: React.FC<DifficultyBadgeProps> = ({ level }) => {
  const getDifficultyInfo = (level: number) => {
    switch (level) {
      case 1:
        return {
          label: 'Basic',
          color: 'green',
          description: 'General knowledge',
        };
      case 2:
        return {
          label: 'Straightforward',
          color: 'blue',
          description: 'Basic subject knowledge',
        };
      case 3:
        return {
          label: 'Moderate',
          color: 'yellow',
          description: 'Specific subject background',
        };
      case 4:
        return {
          label: 'Complex',
          color: 'orange',
          description: 'Advanced subject knowledge',
        };
      case 5:
        return {
          label: 'Advanced',
          color: 'red',
          description: 'Expert-level understanding',
        };
      default:
        return {
          label: 'Unknown',
          color: 'gray',
          description: 'Unknown difficulty',
        };
    }
  };

  const difficultyInfo = getDifficultyInfo(level);

  return (
    <div
      className={`difficulty-badge difficulty-${difficultyInfo.color}`}
      title={difficultyInfo.description}
    >
      <span className="difficulty-level">{level}</span>
      <span className="difficulty-label">{difficultyInfo.label}</span>
    </div>
  );
};

export default DifficultyBadge;
